import BaseModel from './BaseModel';

/** Class representing a screening. */
class LegacyScreening extends BaseModel {}

export default LegacyScreening;
